const button = "_b7nbcq3w2z";

export { button };
import "./Chevrons.style.linaria.module.css";
//# sourceMappingURL=Chevrons.style.js.map
